import httpRequest from "../../../axios/index";
import { ADMIN_ACCOUNTINGS } from "../../../constants/apiEndPoints";
import { toast } from "react-hot-toast";

const GetAllAccounting = async (
  setLoading,
  SetAllData,
  type = "",
  Search = "",
  Date = "",
  page = 1
) => {
  try {
    setLoading(true);
    let params = new URLSearchParams();

    if (type && type === "Paid Invoices") {
      params.append("type", "paid");
    } else if (type === "Unpaid Invoices") {
      params.append("type", "unpaid");
    }

    if (Search) {
      params.append("search", Search);
    }
    if (Date) {
      params.append("date", Date);
    }
    if (page) {
      params.append("page", page);
    }
    let url = `${ADMIN_ACCOUNTINGS}`;
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    const resp = await httpRequest.get(url);
    if (resp?.status === 200) {
      if (resp?.data?.message === "Success") {
        SetAllData(resp?.data);
      }
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};

export { GetAllAccounting };
